import type { Locale } from "@shared/types/locale.ts";
import { claimsAPIClient } from "./apiClients.ts";

/** The locale on the signed-in person's profile; null until the platform first saves one. */
export interface UserLocale {
  locale: Locale | null;
}

/** Reads the signed-in person's profile locale. */
export async function fetchUserLocale(): Promise<UserLocale> {
  const { data } = await claimsAPIClient.get<UserLocale>("/me/profile");
  return data;
}

/** Saves the signed-in person's profile locale. */
export async function saveUserLocale(locale: Locale): Promise<void> {
  await claimsAPIClient.put("/me/profile/locale", { locale });
}
